module.exports = __webpack_public_path__ + "static/media/letter_d.68832cc6.m4a";